/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const listEventSubscriptionsHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Event subscription owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Event subscriptions
 */
export const listEventSubscriptions200Schema = z.array(z.object({
    "id": z.string(),
"userId": z.string(),
"name": z.string(),
"targetUrl": z.string(),
"headers": z.nullable(z.object({
    
    }).catchall(z.string())),
"eventTypes": z.array(z.enum(["contact.event.detected", "contact.summary.completed"])),
"enabled": z.boolean(),
"lastSuccessAt": z.nullable(z.iso.datetime()),
"lastFailureAt": z.nullable(z.iso.datetime()),
"lastErrorMessage": z.nullable(z.string()),
"consecutiveFailureCount": z.int().min(-9007199254740991).max(9007199254740991),
"autoDisabledAt": z.nullable(z.iso.datetime()),
"createdAt": z.iso.datetime(),
"updatedAt": z.iso.datetime()
    }))

export const listEventSubscriptionsQueryResponseSchema = z.lazy(() => listEventSubscriptions200Schema)